import React from 'react';
import { Card } from 'react-bootstrap';
import './BulkClose.scss';
import BulkCloseForm from './BulkCloseForm';
import { useAlertStatuses } from '../../screening/alert-status/alertStatusesHelper';
import SalvPage from '../../common/SalvPage';

const BulkClose = () => {
  const [activeStatuses] = useAlertStatuses();

  return (
    <SalvPage title={'Bulk Status Change'} className='bulk-close'>
      <Card>
        <Card.Header>
          <h2 className='card-header-title'>Bulk status change of alerts</h2>
        </Card.Header>
        <Card.Body>
          <BulkCloseForm statuses={activeStatuses} />
        </Card.Body>
      </Card>
    </SalvPage>
  );
};

export default BulkClose;
